import { render, staticRenderFns } from "./AppointmentConfirmationBanner.vue?vue&type=template&id=7ab3a520&"
import script from "./AppointmentConfirmationBanner.vue?vue&type=script&lang=js&"
export * from "./AppointmentConfirmationBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports